<template>

    <div
        :id="controlId + '-wrapper'"
        class="lni-c-form-control--datepicker lni-c-form-control--custom-width"
        :class="[{
            'lni-c-form-control--required': required,
        },
        this.class,
        ]"
    >
        <label :for="controlId" class="lni-c-form-control__label">{{ labelText }}</label>
        <slot />
        <div class="lni-u-flex">
            <input
                class="lni-c-form-control__input"
                :id="controlId"
                :name="controlId"
                :required="required"
                pattern="(0[1-9]|1[012])\/(0[1-9]|1[0-9]|2[0-9]|3[01])\/[0-9]{4}"
                maxlength="10"
                v-mask="{pattern: '##/##/####', separator: '/', childSelector: '.visible-input'}"
                data-input
                @input="onInput"
                @change="handleErrorState"

            >
            <button
                type="button"
                class="lni-c-datepicker__button lni-c-button--control lni-u-flex"
                data-toggle
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 1024 1024" fill="currentColor">
              <path d="M896 128h-96v32c0 35.296-28.672 64-64 64s-64-28.704-64-64v-32H352v32c0 35.296-28.704 64-64 64s-64-28.704-64-64v-32h-96c-35.2 0-64 28.8-64 64v704c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64V192c0-35.2-28.8-64-64-64zm0 767.872c-.032.032-.064.096-.128.128H128.096c-.032-.032-.096-.064-.128-.128V320h768L896 895.872zM288 192c17.664 0 32-14.336 32-32V32c0-17.664-14.336-32-32-32s-32 14.336-32 32v128c0 17.664 14.336 32 32 32zm448 0c17.664 0 32-14.336 32-32V32c0-17.664-14.336-32-32-32s-32 14.336-32 32v128c0 17.664 14.336 32 32 32z"/>
              <path d="M164.5 535.166h147v142.668h-147zM164.5 713.833h147V856.5h-147zM347.5 356.5h147v142.667h-147zM347.5 535.166h147v142.668h-147zM347.5 713.833h147V856.5h-147zM530.5 356.5h147v142.667h-147zM530.5 535.166h147v142.668h-147zM530.5 713.833h147V856.5h-147zM713.5 356.5h147v142.667h-147zM713.5 535.166h147v142.668h-147zM713.5 713.833h147V856.5h-147z"/>
            </svg>
                <span class="lni-u-visually-hidden">Open calendar</span>
            </button>
        </div>
    </div>
</template>

<script>
import framework from '../../framework';
import mask from '../directives/mask';
import flatPickr from 'flatpickr';

/**
 *  The x-input-date component.
 *  @module components/x-input-date
 */


/**
 * The x-input-date is a basic date input control with datepicker with a label.
 * It can also display validation messages.
 */
export default {
    name: 'x-input-date',
    props: {
        dataLabelText: String,
    },
    mixins: [
        framework.mixins.abstractSingleValueInput,
    ],
    directives: {
        mask,
    },
    mounted() {
        // eslint-disable-next-line
        const thisComponent = this;
        this.calendar = flatPickr('#' + this.controlId + '-wrapper', {
            allowInput: true,
            wrap: true,
            clickOpens: false,
            dateFormat: 'm/d/Y',
            onChange() {
                // eslint-disable-next-line
                thisComponent.handleFlatPickrChange();
            },
        });
        this.initialize();
    },
    beforeDestroy() {
        this.calendar.destroy();
        this.calendar = null;
    },
    computed: {
        /**
         * The text for the label.
         * @returns {string} label text.
         */
        labelText() {
            return this.getAttribute('labelText', '');
        },
    },
    methods: {
        /**
         * Handles the input event and sets the changed value onto the component's model.
         * @param {*} event the input event
         * @returns {void}
         */
        onInput(event) {
            this.value = event.target.value;
        },
        isBuildingValue(dateStr) {
            return dateStr.includes('undefined');
        },
        format(dateStr) {
            if (!dateStr) {
                return '';
            }
            const dateParts = dateStr.split('-');
            let year = dateParts[0];
            let month = dateParts[1];
            let day = dateParts[2];

            return `${month}/${day}/${year}`;
        },
        parse(dateStr) {
            if (!dateStr) {
                return '';
            }
            const dateParts = dateStr.split('/');
            let year = dateParts[2];
            let month = dateParts[0];
            let day = dateParts[1];

            return `${year}-${month}-${day}`;
        },
        handleFlatPickrChange() {
            // Let the value from flatpickr get updated in our component before
            // calling our error process.
            this.$nextTick(() => {
                this.handleErrorState();
            });
        },
        /**
         * Gets the error information off of the input element(s)
         * @returns {void}
         */
        getErrorStateOffInputs() {
            let message = this.required && this.value.length === 0
                ? 'Please fill out this field.'
                : '';
            return this.createValidationPayload(message);
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import
  "../../styles/settings",
  "flatpickr-lite",
  "input-date";

</style>



// WEBPACK FOOTER //
// source/components/x-input-date/x-input-date.vue